import { render, staticRenderFns } from "./Customermasterdata.vue?vue&type=template&id=18d8ddaa&scoped=true&"
import script from "./Customermasterdata.vue?vue&type=script&lang=js&"
export * from "./Customermasterdata.vue?vue&type=script&lang=js&"
import style0 from "./Customermasterdata.vue?vue&type=style&index=0&id=18d8ddaa&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d8ddaa",
  null
  
)

export default component.exports